import LocalStorageService from './localStorageService';
import type { StoredLocale } from '@mindtickle/ui-shell-core/DateTranslation';

const USER_LOCALE_KEY: string = 'mt_user_locale';

const service = new LocalStorageService<StoredLocale>();

const isValidData = (data: StoredLocale | undefined): data is StoredLocale =>
  Boolean(data?.userId && data?.companyId && data?.locale);

export const getStoredLocale = (): StoredLocale | undefined => {
  try {
    const { data } = service.getData(USER_LOCALE_KEY);
    return isValidData(data) ? data : undefined;
  } catch {
    return undefined;
  }
};

export const setStoredLocale = (value: StoredLocale): void => {
  service.setData(USER_LOCALE_KEY, value);
};
